import { DriveItem } from '@microsoft/microsoft-graph-types';
import invariant from 'tiny-invariant';
import {
  BaseStorageItem,
  ServiceProvider,
  StorageItemMetadata,
  UPLOADCAM_FOLDER_MIME,
  UPLOADCAM_UNKNOWN_MIME,
} from '@uploadcam/common';

export interface OneDriveFile extends DriveItem {
  id: string;
}

export class OneDriveItem extends BaseStorageItem {
  constructor(
    private readonly file: OneDriveFile,
    public readonly driveId: string | undefined,
  ) {
    super();
  }

  public get provider(): ServiceProvider {
    return ServiceProvider.Microsoft;
  }

  public get id(): string {
    return this.file.id;
  }

  public get parentId(): string | undefined {
    return this.file.parentReference?.id ?? undefined;
  }

  public get allowsSubfolderCreation(): boolean {
    return this.isFolder;
  }

  public get isVirtual(): boolean {
    return false;
  }

  public get mime(): string {
    if (this.file.folder) {
      return UPLOADCAM_FOLDER_MIME;
    } else if (this.file.file && this.file.file.mimeType) {
      return this.file.file.mimeType;
    }

    return UPLOADCAM_UNKNOWN_MIME;
  }

  public get name(): string {
    invariant(this.file.name, `File 'name' must be defined.`);
    return this.file.name;
  }

  public get lastModified(): Date | undefined {
    if (this.file.lastModifiedDateTime) {
      return new Date(this.file.lastModifiedDateTime);
    }

    return undefined;
  }

  public get isShortcut(): boolean {
    return false;
  }

  public get metadata(): StorageItemMetadata {
    return {};
  }

  public get size(): number | undefined {
    if (this.file.size) {
      return this.file.size;
    }

    return undefined;
  }
}
